<!-- Loading State with Shimmer -->
@if (isLoading() && !hasError()) {
  <!-- <app-document-loader
    message="Loading PDF document..."
    [variant]="ShimmerVariant.TextBlock"
    [lineCount]="8"
    loaderId="pdf-loader"
  /> -->
        <div class="loader-overlay">
      <optima-progress-indicator
        [view]="ProcessProgressView.Shimmer"
        [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
          { width: '100%', height: '100%' }
        ] } }">
      </optima-progress-indicator>
    </div>
}

<!-- Error State -->
@if (hasError()) {
  <div class="error-state">
    <div class="error-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>
    <h2>Failed to Load PDF</h2>
    <p class="error-message">{{ errorMessage() }}</p>
    <div class="error-actions">
      <button class="retry-btn" (click)="retryLoad()">Retry</button>
      <button class="back-btn" (click)="goBack()">Back to Libraries</button>
    </div>
  </div>
}

<!-- PDF Viewer -->
@if (!hasError() && pdfUrl() && !isLoading()) {
  <iframe width="100%" height="100%" [src]="pdfUrl()!" class="pdf-iframe" title="PDF Viewer" allow="fullscreen">
    <p>Your browser doesn't support PDFs.
      <a [href]="rawPdfUrl()" target="_blank" class="download-link">
        Download the PDF
      </a> to view it.
    </p>
  </iframe>
}